import { render, staticRenderFns } from "./TheModalBreaks.vue?vue&type=template&id=0cc4875e&scoped=true"
import script from "./TheModalBreaks.vue?vue&type=script&lang=js"
export * from "./TheModalBreaks.vue?vue&type=script&lang=js"
import style0 from "./TheModalBreaks.vue?vue&type=style&index=0&id=0cc4875e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4875e",
  null
  
)

export default component.exports